import type { ResultTemplateKey } from 'types/result';
import type { UseResultSectionsEditorReturn } from 'hooks/useResultSectionsEditor';
import { createEditorContext } from './createEditorContext';

export type ResultSectionsEditorContextValue = UseResultSectionsEditorReturn & {
  sectionKeys: { key: ResultTemplateKey; title: string }[];
  activeDictation: string | undefined;
  setActiveDictation: (activeDictation: string | undefined) => void;
};

const { Provider, useEditorContext } =
  createEditorContext<ResultSectionsEditorContextValue>('ResultSectionsEditor');

export const ResultSectionsEditorProvider = Provider;
export const useResultSectionsEditorContext = useEditorContext;
